import { Button, Menu, MenuItem, Tab, Tabs } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import React, { useState } from 'react';
import CustomAccordion from '../../../../shared/custom-accordion/Custom-Accordion';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import './Guest-Room-Experience-Room-Tab-Room-Area-Content.scss';
import {
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_DELETE,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_EDIT,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_DELETE,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_EDIT,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_DELETE,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_EDIT,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_DELETE,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_EDIT,
} from '../../../../constants/GuestRoomExperienceConst';
import { lightIcons } from '../../../../constants/ConfigurationsConst';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { fetchSelectedRoom } from '../../../../layouts/configurations/configurationSlice';
import { saveOrUpdateRoomConfigs } from '../../../../utils/IntegrationsAPIUtils';
import { useDispatch, useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../../../layouts/property/propertySlice';

const GuestRoomExperienceRoomTabRoomAreaContent = (props) => {
  const { area, onDrawerToggle, roomId } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const [tabValue, setTabValue] = useState(0);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    type: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const dispatch = useDispatch();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleItemClick = (event, item, key) => {
    setSelectedValue({
      id: item.id,
      name: item.name,
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
      item: item,
      pos: key,
    });
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      item: null,
      pos: -1,
    });
  };

  const handleDeletePopupOpen = (key, type) => {
    setSelectedValue({
      id: key,
      type: type,
      name: selectedValue.name,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed.',
      status: true,
      anchorEl: null,
      pos: -1,
    });
  };

  const onOpenDrawer = (type, index) => {
    onDrawerToggle(type, true, selectedValue.item, index, area);
    handleClose();
  };

  const deleteAreaData = async () => {
    handleClose();
    try {
      let tempArea = { ...area };
      if (selectedValue.type === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_DELETE) {
        let tempList = [...area.lights];
        tempList.splice(selectedValue.id, 1);
        tempArea['lights'] = tempList;
      } else if (selectedValue.type === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_DELETE) {
        let tempList = [...area.scenes];
        tempList.splice(selectedValue.id, 1);
        tempArea['scenes'] = tempList;
      } else if (selectedValue.type === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_DELETE) {
        let tempList = [...area.curtains];
        tempList.splice(selectedValue.id, 1);
        tempArea['curtains'] = tempList;
      } else if (
        selectedValue.type === GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_DELETE
      ) {
        let tempList = [...area.thermostats];
        tempList.splice(selectedValue.id, 1);
        tempArea['thermostats'] = tempList;
      }
      delete tempArea.name;
      await saveOrUpdateRoomConfigs(selectedHotel, roomId, 'AREA', tempArea);
      dispatch(fetchSelectedRoom(selectedHotel, roomId));
      notificationManager('success', 'Item deleted successfully');
      setSelectedValue({
        id: '',
        key: '',
        name: '',
        title: '',
        description: '',
        status: false,
        anchorEl: null,
        group: null,
        pos: -1,
      });
    } catch (e) {
      notificationManager('danger', 'Item deletion failed');
    }
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      type: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      pos: -1,
    });
  };

  return (
    <>
      {selectedValue.id + '' !== '' && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteAreaData}
          onDeleteCancel={onDeleteCancel}
        />
      )}

      <CustomAccordion header={area.name}>
        <div className='row mx-2'>
          <div className='col-md-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='hotel-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Lights' className='col-md-3' />
              <Tab label='Scenes' className='col-md-3' />
              <Tab label='Thermostats' className='col-md-3' />
              <Tab label='Curtains' className='col-md-3' />
            </Tabs>
          </div>
        </div>
        <div className='row room-area-content px-3 mt-2'>
          <div>
            {tabValue === 0 && (
              <>
                {area.lights.map((item, key) => (
                  <div className='row  content-row' key={key}>
                    <div className='col-md-4 d-flex'>
                      <span className='content content-label me-2'>
                        <img
                          style={{ width: '20px', height: '20px' }}
                          src={lightIcons.find((light) => light.id === item.icon).url}
                          alt='icon'
                        />
                        {}
                      </span>
                      <span className='content content-label me-2'>Light Name :</span>
                      <span className='content content-value'>{item.name}</span>
                    </div>
                    <div className='col-md-2 d-flex'>
                      <span className='content content-label me-2'>Light Type:</span>
                      <span className='content content-value'>
                        {item.type === 'DIMMER' ? ' Dimmer' : 'On/Off'}
                      </span>
                    </div>
                    <div className='col-md-2 d-flex'>
                      {item.type === 'DIMMER' && (
                        <>
                          <span className='content content-label me-3'>Dimmer Level :</span>
                          <span className='content content-value'>{item.dimmerLevel}</span>
                        </>
                      )}
                    </div>
                    <div className='col-md-3 d-flex'>
                      <span className='content status-label  me-3'>Status:</span>
                      <span>
                        {' '}
                        <div className='d-flex justify-content-center'>
                          <div
                            className={`${
                              item.status === 'online'
                                ? 'pill-online'
                                : item.status === 'pending'
                                ? ' pill-pending'
                                : item.status === 'error'
                                ? 'pill-error'
                                : 'pill-unassigned'
                            } 
                       pill d-flex justify-content-center align-items-center`}
                          >
                            <span className='ms-1'>
                              {item.status === 'pending'
                                ? 'Pending'
                                : item.status === 'online'
                                ? 'Online'
                                : item.status === 'error'
                                ? 'Error'
                                : 'Offline'}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <div className='col-md-1 d-flex justify-content-end'>
                      <Button
                        aria-controls='simple-menu'
                        aria-haspopup='true'
                        onClick={(e) => {
                          handleItemClick(e, item, key);
                        }}
                      >
                        <MoreHoriz />
                      </Button>
                      <Menu
                        id={key}
                        anchorEl={selectedValue?.anchorEl}
                        disableRestoreFocus
                        MenuListProps={{ autoFocusItem: false }}
                        keepMounted
                        open={Boolean(selectedValue.anchorEl) && selectedValue.pos === key}
                        onClose={handleClose}
                        className='shadow'
                      >
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            onOpenDrawer(GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_EDIT, key);
                          }}
                        >
                          <CreateIcon className='me-2 action-menu-icon' />
                          Edit
                        </MenuItem>
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            handleDeletePopupOpen(
                              key,
                              GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_DELETE,
                            );
                          }}
                        >
                          <DeleteForeverIcon className='me-2 action-menu-icon' />
                          Delete
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div>
            {tabValue === 1 && (
              <>
                {area.scenes.map((item, key) => (
                  <div className='row  content-row' key={key}>
                    <div className='col-md-4 d-flex'>
                      <span className='content content-label me-3'>Scene Name :</span>
                      <span className='content content-value'>{item.name}</span>
                    </div>
                    <div className='col-md-2 d-flex'>
                      <span className='content content-label me-3'>Light Type:</span>
                      <span className='content content-value'>
                        {item.type === 'DIMMER' ? ' Dimmer' : 'On/Off'}
                      </span>
                    </div>
                    <div className='col-md-2 d-flex'>
                      {item.type === 'DIMMER' && (
                        <>
                          <span className='content content-label me-3'>Dimmer Level :</span>
                          <span className='content content-value'>{item.dimmerLevel}</span>
                        </>
                      )}
                    </div>
                    <div className='col-md-3  d-flex'>
                      <span className='content status-label  me-3'>Status:</span>
                      <span>
                        {' '}
                        <div className='d-flex justify-content-center'>
                          <div
                            className={`${
                              item.status === 'online'
                                ? 'pill-online'
                                : item.status === 'pending'
                                ? ' pill-pending'
                                : item.status === 'error'
                                ? 'pill-error'
                                : 'pill-unassigned'
                            } 
                       pill d-flex justify-content-center align-items-center`}
                          >
                            <span className='ms-1'>
                              {item.status === 'pending'
                                ? 'Pending'
                                : item.status === 'online'
                                ? 'Online'
                                : item.status === 'error'
                                ? 'Error'
                                : 'Offline'}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <div className='col-md-1 d-flex justify-content-end'>
                      <Button
                        aria-controls='simple-menu'
                        aria-haspopup='true'
                        onClick={(e) => {
                          handleItemClick(e, item, key);
                        }}
                      >
                        <MoreHoriz />
                      </Button>
                      <Menu
                        id={key}
                        anchorEl={selectedValue?.anchorEl}
                        disableRestoreFocus
                        MenuListProps={{ autoFocusItem: false }}
                        keepMounted
                        open={Boolean(selectedValue.anchorEl) && selectedValue.pos === key}
                        onClose={handleClose}
                        className='shadow'
                      >
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            onOpenDrawer(GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_EDIT, key);
                          }}
                        >
                          <CreateIcon className='me-2 action-menu-icon' />
                          Edit
                        </MenuItem>
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            handleDeletePopupOpen(
                              key,
                              GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_DELETE,
                            );
                          }}
                        >
                          <DeleteForeverIcon className='me-2 action-menu-icon' />
                          Delete
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div>
            {tabValue === 2 && (
              <>
                {area.thermostats.map((item, key) => (
                  <div className='row  content-row' key={key}>
                    <div className='col-md-6 d-flex'>
                      <span className='content content-label me-3'>Thermostat Name :</span>
                      <span className='content content-value'>{item.name}</span>
                    </div>
                    <div className='col-md-5  d-flex justify-content-end'>
                      <span className='content status-label  me-3'>Status:</span>
                      <span>
                        {' '}
                        <div className='d-flex justify-content-center'>
                          <div
                            className={`${
                              item.status === 'online'
                                ? 'pill-online'
                                : item.status === 'pending'
                                ? ' pill-pending'
                                : item.status === 'error'
                                ? 'pill-error'
                                : 'pill-unassigned'
                            } 
                       pill d-flex justify-content-center align-items-center`}
                          >
                            <span className='ms-1'>
                              {item.status === 'pending'
                                ? 'Pending'
                                : item.status === 'online'
                                ? 'Online'
                                : item.status === 'error'
                                ? 'Error'
                                : 'Offline'}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <div className='col-md-1 d-flex justify-content-end'>
                      <Button
                        aria-controls='simple-menu'
                        aria-haspopup='true'
                        onClick={(e) => {
                          handleItemClick(e, item, key);
                        }}
                      >
                        <MoreHoriz />
                      </Button>
                      <Menu
                        id={key}
                        anchorEl={selectedValue?.anchorEl}
                        disableRestoreFocus
                        MenuListProps={{ autoFocusItem: false }}
                        keepMounted
                        open={Boolean(selectedValue.anchorEl) && selectedValue.pos === key}
                        onClose={handleClose}
                        className='shadow'
                      >
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            onOpenDrawer(
                              GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_EDIT,
                              key,
                            );
                          }}
                        >
                          <CreateIcon className='me-2 action-menu-icon' />
                          Edit
                        </MenuItem>
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            handleDeletePopupOpen(
                              key,
                              GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_DELETE,
                            );
                          }}
                        >
                          <DeleteForeverIcon className='me-2 action-menu-icon' />
                          Delete
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div>
            {tabValue === 3 && (
              <>
                {area.curtains.map((item, key) => (
                  <div className='row  content-row' key={key}>
                    <div className='col-md-4 d-flex'>
                      <span className='content content-label me-3'>Curtain Name :</span>
                      <span className='content content-value'>{item.name}</span>
                    </div>
                    <div className='col-md-4 d-flex'>
                      <span className='content content-label me-3'>Curtan Type:</span>
                      <span className='content content-value'>
                        {item.type === 'BLINDS'
                          ? 'Blinds'
                          : item.type === 'SHEERS'
                          ? 'Sheers'
                          : 'Curtains'}
                      </span>
                    </div>
                    <div className='col-md-3  d-flex'>
                      <span className='content status-label  me-3'>Status:</span>
                      <span>
                        {' '}
                        <div className='d-flex justify-content-center'>
                          <div
                            className={`${
                              item.status === 'online'
                                ? 'pill-online'
                                : item.status === 'pending'
                                ? ' pill-pending'
                                : item.status === 'error'
                                ? 'pill-error'
                                : 'pill-unassigned'
                            } 
                       pill d-flex justify-content-center align-items-center`}
                          >
                            <span className='ms-1'>
                              {item.status === 'pending'
                                ? 'Pending'
                                : item.status === 'online'
                                ? 'Online'
                                : item.status === 'error'
                                ? 'Error'
                                : 'Offline'}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <div className='col-md-1 d-flex justify-content-end'>
                      <Button
                        aria-controls='simple-menu'
                        aria-haspopup='true'
                        onClick={(e) => {
                          handleItemClick(e, item, key);
                        }}
                      >
                        <MoreHoriz />
                      </Button>
                      <Menu
                        id={key}
                        anchorEl={selectedValue?.anchorEl}
                        disableRestoreFocus
                        MenuListProps={{ autoFocusItem: false }}
                        keepMounted
                        open={Boolean(selectedValue.anchorEl) && selectedValue.pos === key}
                        onClose={handleClose}
                        className='shadow'
                      >
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            onOpenDrawer(
                              GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_EDIT,
                              key,
                            );
                          }}
                        >
                          <CreateIcon className='me-2 action-menu-icon' />
                          Edit
                        </MenuItem>
                        <MenuItem
                          className='pe-4'
                          onClick={(e) => {
                            handleDeletePopupOpen(
                              key,
                              GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_DELETE,
                            );
                          }}
                        >
                          <DeleteForeverIcon className='me-2 action-menu-icon' />
                          Delete
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </CustomAccordion>
    </>
  );
};

export default GuestRoomExperienceRoomTabRoomAreaContent;
